<template>
  <div class="con-wrap">
    <corner-box class="box-element">
      <p class="box-title">烟雾报警器</p>
      <ul class="data-con clear">
        <li v-for="item in smogData" class="fl clear">
          <div><span class="item-name fl">{{ item.routeName}}</span>
            <span
              class="status-icon fl"
              :style="{
              'background-color':
                item.alarm === 0 ? '#00d851' : item.alarm  === 1 ? '#ff0100' : 'gray'
            }"
            ></span></div>
        </li>
      </ul>
    </corner-box>
    <corner-box class="box-element">
      <p class="box-title">一氧化碳探测器</p>
      <ul class="data-con clear co-con">
        <li v-for="item in COData" class="fl clear">
          <span class="item-name fl">{{ item.routeName}}</span>
          <span
            class="status-icon fl"
            :style="{
              'background-color':
                item.alarm === 0 ? '#00d851' : item.alarm === 1 ? '#ff0100' : 'gray'
            }"
          ></span>
          <span>{{ item.val }}</span> <!--ppm-->
        </li>
      </ul>
    </corner-box>
  </div>
</template>

<script>
import cornerBox from "../../../components/cornerBox";
export default {
  name: "gasMonitoring",
  components: {
    cornerBox
  },
  data() {
    return {
      timer: null,
      smogData: {
        1:{
          routeName: '备用',
          alarm: ''
        },
        2:{
          routeName: '备用',
          alarm: ''
        },
        3:{
          routeName: '备用',
          alarm: ''
        },
        4:{
          routeName: '备用',
          alarm: ''
        },
        5:{
          routeName: '备用',
          alarm: ''
        },
        6:{
          routeName: '备用',
          alarm: ''
        },
        7:{
          routeName: '备用',
          alarm: ''
        }
      },
      COData: {
        1:{
          val: '',
          routeName: '备用',
          alarm: ''
        },
        2:{
          val: '',
          routeName: '备用',
          alarm: ''
        },
        3:{
          val: '',
          routeName: '备用',
          alarm: ''
        },
        4:{
          val: '',
          routeName: '备用',
          alarm: ''
        },
        5:{
          val: '',
          routeName: '备用',
          alarm: ''
        },
        6:{
          val: '',
          routeName: '备用',
          alarm: ''
        },
        7:{
          val: '',
          routeName: '备用',
          alarm: ''
        }
      }
    };
  },
  mounted() {
    this.getAlarmData();
    let _this = this;
    this.timer = setInterval(function() {
      _this.getAlarmData();
    }, 3000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    getAlarmData(){
      this.$get('gasmonitoring/index',[0]).then((response)=>{
        this.$set(this.smogData,'0',response.SmogData['TG2000:d_d1:alarm'])
        this.$set(this.COData,'0',response.COData['TG2000:b_b1:k1'])
      })
    }
  }
};
</script>

<style scoped lang="scss">
.con-wrap {
  padding-top: 50px;
  .corner-wrap {
    width: 90%;
    margin: 0 auto 45px;
    padding: 3px;
    .box-title {
      margin: 0;
    }
    .data-con {
      padding: 30px 80px 30px 180px;
      &.co-con {
        padding: 35px 80px 35px 180px;
      }
      li {
        color: $light;
        font-size: 14px;
        margin: 10px 30px 20px;
        width: 220px;
        height: 35px;
        line-height: 35px;
        .status-icon {
          display: inline-block;
          height: 25px;
          width: 25px;
          background: red;
          border-radius: 50%;
          margin: 5px 12px;
        }
      }
    }
  }
}
</style>
